import { getPersonInfo, getConfig, getCityList } from '@axios/invoice'
import Storage from '../../assets/lib/storageHelper'

const state = {
}

const mutations = {
}

const actions = {
  async init_appParam({ commit }, { route } = {}) {
    const query = (route && route.query) || {}
    const ut = query.ut || '8'
    const token = query.token === undefined ? query._token : query.token
    const city_id = query.city_id || ''

    Storage.session.set({
      city_id,
      load: true,
      user_type: ut,
      token
    })

    try {
      const res = await getPersonInfo()
      const data = res && res.data
      if (data && data.ret === 0) {
        Storage.local.setSingle('user_id', data.data.user_id)
        commit('initData', { user_id: data.data.user_id, ut }, { root: true })
      }
    } catch (err) {
      console.error('[global/init_appParam] getPersonInfo error', err)
    }

    try {
      const res = await getCityList()
      const data = res && res.data
      if (data && data.ret === 0) {
        commit('setCityList', data.data, { root: true })
      }
    } catch (err) {
      console.error('[global/init_appParam] getCityList error', err)
    }
  },

  async common_config({ commit, state }) {
    try {
      const res = await getConfig()
      const data = (res && res.data && res.data.data) || {}

      Storage.session.set({
        desc: data.desc,
        notice: data.notice,
        tabEnabled: data.invoice_tab_status,
        paperBillLimit: data.paper_bill_limit,
        express_fee_pay_type: data.express_fee_pay_type,
        version_switch: data.version_switch,
        encrypt_switch: data.encrypt_switch
      })

    } catch (err) {
      console.error('[global/common_config] error', err)
    } finally {
    }
    return {}
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/global.js